export const iconFontAwesomeBuildingsBuildingCircleCheck = (
	<i className="fa-solid fa-building-circle-check"></i>
);
